export default "__VITE_ASSET__ICK2HeMA__";